import React from "react";
import Helmet from "react-helmet";
import HeaderImage from "../components/HeaderImage/HeaderImage";
import PostListing from "../components/PostListing/PostListing";
import Pagination from "../components/Pagination";
import config from "../../data/SiteConfig";

const IndexPage = ({data, pathContext}) => {
  const {group} = pathContext;

  return (
    <div>
      <Helmet title={`Videos | ${config.siteTitle}`} />
      <HeaderImage headerImage={data.videosHeaderImage} />
      <div className="section">
        <div className="container" style={{paddingTop: "100px"}}>
          <h1 className="title is-1">
            All Videos
          </h1>
          <h4 className="subtitle is-4">
            {`${data.allMarkdownRemark.totalCount} videos`}
          </h4>

          <PostListing
            postEdges={group}
            dateFormat={config.dateFormatOutput}
          />
          <Pagination pathContext={pathContext} />
        </div>
      </div>
    </div>
  );
};
export default IndexPage;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query VideoQuery {
    allMarkdownRemark(filter: {frontmatter: {category: {eq: "video"}}}) {
      totalCount
    }
    videosHeaderImage: file(relativePath: { eq: "bg/subbed_videos.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 1920) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/videos.jsx